import { differenceInMonths } from "date-fns";
import moment from "moment";

const shippingAllTimeValues = [
  {
    behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
    behaviourName: "Efficient Auxiliary Engine Use",
    behaviourAcronym: "EAEU",
    behaviourPosition: 2,
    countEventsPerformedPreSignol: 22,
    countEventsPerformedPostSignol: 36,
    totalFuelSavingKgPreSignol: 14664.382,
    totalFuelSavingKgPostSignol: -4566.686,
    avgNetFuelSavingKgPreSignol: {
      value: 299,
      standardError68: 25,
      standardError95: 35,
    },
    avgNetFuelSavingTonnesPreSignol: {
      value: 0.3,
      standardError68: 0.8,
      standardError95: 1.6,
    },
    avgNetFuelSavingKgPostSignol: {
      value: 74,
      standardError68: 7,
      standardError95: 15,
    },
    avgNetFuelSavingTonnesPostSignol: {
      value: 0.07,
      standardError68: 0.82,
      standardError95: 1.61,
    },
    avgNetFuelSavingChangeKg: {
      value: 373,
      standardError68: 37,
      standardError95: 73,
    },
    avgNetFuelSavingChangeTonnes: {
      value: 0.4,
      standardError68: 1.1,
      standardError95: 2.1,
    },
  },
  {
    behaviourKey: "PROMPT_DEPARTURE",
    behaviourName: "Prompt Departure",
    behaviourAcronym: "PD",
    behaviourPosition: 4,

    countEventsPerformedPreSignol: 156,
    countEventsPerformedPostSignol: 53,
    totalFuelSavingKgPreSignol: 82194.81,
    totalFuelSavingKgPostSignol: -150569.03,
    avgNetFuelSavingKgPreSignol: {
      value: 207,
      standardError68: 15,
      standardError95: 23,
    },
    avgNetFuelSavingTonnesPreSignol: {
      value: 0.2,
      standardError68: 0.7,
      standardError95: 1.4,
    },
    avgNetFuelSavingKgPostSignol: {
      value: 896,
      standardError68: 24,
      standardError95: 59,
    },
    avgNetFuelSavingTonnesPostSignol: {
      value: 0.9,
      standardError68: 2.2,
      standardError95: 4.3,
    },
    avgNetFuelSavingChangeKg: {
      value: 1103,
      standardError68: 69,
      standardError95: 129,
    },
    avgNetFuelSavingChangeTonnes: {
      value: 1.1,
      standardError68: 2.3,
      standardError95: 4.6,
    },
  },
  {
    behaviourKey: "EFFICIENT_SFOC",
    behaviourName: "Efficient SFOC",
    behaviourAcronym: "ESFOC",
    behaviourPosition: 1,
    countEventsPerformedPreSignol: 46,
    countEventsPerformedPostSignol: 68,
    totalFuelSavingKgPreSignol: 153333.33,
    totalFuelSavingKgPostSignol: 99981.35,
    avgNetFuelSavingKgPreSignol: {
      value: 935,
      standardError68: 166,
      standardError95: 204,
    },
    avgNetFuelSavingTonnesPreSignol: {
      value: 0.9,
      standardError68: 2,
      standardError95: 4,
    },
    avgNetFuelSavingKgPostSignol: {
      value: 469,
      standardError68: 36,
      standardError95: 83,
    },
    avgNetFuelSavingTonnesPostSignol: {
      value: 0.5,
      standardError68: 4.4,
      standardError95: 8.7,
    },
    avgNetFuelSavingChangeKg: {
      value: 466,
      standardError68: 20,
      standardError95: 55,
    },
    avgNetFuelSavingChangeTonnes: {
      value: 0.5,
      standardError68: 4.8,
      standardError95: 9.4,
    },
  },
  {
    behaviourKey: "OPTIMAL_TRIM",
    behaviourName: "Optimal Trim",
    behaviourAcronym: "OT",
    behaviourPosition: 3,

    countEventsPerformedPreSignol: 38,
    countEventsPerformedPostSignol: 55,
    totalFuelSavingKgPreSignol: 43.73133,
    totalFuelSavingKgPostSignol: -79327.75,
    avgNetFuelSavingKgPreSignol: {
      value: 0,
      standardError68: 0,
      standardError95: 0,
    },
    avgNetFuelSavingTonnesPreSignol: {
      value: 0,
      standardError68: 0,
      standardError95: 0,
    },
    avgNetFuelSavingKgPostSignol: {
      value: 515,
      standardError68: 21,
      standardError95: 78,
    },
    avgNetFuelSavingTonnesPostSignol: {
      value: 0.5,
      standardError68: 1.7,
      standardError95: 3.3,
    },
    avgNetFuelSavingChangeKg: {
      value: 516,
      standardError68: 20,
      standardError95: 74,
    },
    avgNetFuelSavingChangeTonnes: {
      value: 0.5,
      standardError68: 1.7,
      standardError95: 3.3,
    },
  },
];

const shippingMonthyValues = {
  [moment.utc().subtract(1, "month").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 23,
      totalFuelSavingKgPreSignol: 14664.382,
      totalFuelSavingKgPostSignol: 827.3356,
      avgNetFuelSavingKgPreSignol: {
        value: 299,
        standardError68: 28,
        standardError95: 62,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.3,
        standardError68: 0.8,
        standardError95: 1.6,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 22,
        standardError68: 5,
        standardError95: 9,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.02,
        standardError68: 0.57,
        standardError95: 1.12,
      },
      avgNetFuelSavingChangeKg: {
        value: 277,
        standardError68: 22,
        standardError95: 55,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.3,
        standardError68: 0.9,
        standardError95: 1.8,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 17,
      totalFuelSavingKgPreSignol: 82194.81,
      totalFuelSavingKgPostSignol: -82836.945,
      avgNetFuelSavingKgPreSignol: {
        value: 207,
        standardError68: 7,
        standardError95: 33,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.2,
        standardError68: 0.7,
        standardError95: 1.4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 1183,
        standardError68: 62,
        standardError95: 126,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 1.2,
        standardError68: 2.4,
        standardError95: 4.8,
      },
      avgNetFuelSavingChangeKg: {
        value: 1390,
        standardError68: 60,
        standardError95: 157,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 1.4,
        standardError68: 2.5,
        standardError95: 5,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      totalFuelSavingKgPreSignol: 153333.33,
      totalFuelSavingKgPostSignol: 58416.094,
      avgNetFuelSavingKgPreSignol: {
        value: 935,
        standardError68: 66,
        standardError95: 84,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 615,
        standardError68: 61,
        standardError95: 87,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.6,
        standardError68: 6,
        standardError95: 11.8,
      },
      avgNetFuelSavingChangeKg: {
        value: 320,
        standardError68: 14,
        standardError95: 20,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.3,
        standardError68: 6.6,
        standardError95: 12.9,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 37,
      totalFuelSavingKgPreSignol: 43.73133,
      totalFuelSavingKgPostSignol: -78508.02,
      avgNetFuelSavingKgPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 924,
        standardError68: 75,
        standardError95: 171,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeKg: {
        value: 924,
        standardError68: 76,
        standardError95: 173,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
    },
  ],
  [moment.utc().subtract(2, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 10,
      totalFuelSavingKgPreSignol: 14664.382,
      totalFuelSavingKgPostSignol: -5394.0215,
      avgNetFuelSavingKgPreSignol: {
        value: 299,
        standardError68: 28,
        standardError95: 62,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.3,
        standardError68: 0.8,
        standardError95: 1.6,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 245,
        standardError68: 11,
        standardError95: 21,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.2,
        standardError68: 1.4,
        standardError95: 2.7,
      },
      avgNetFuelSavingChangeKg: {
        value: 544,
        standardError68: 38,
        standardError95: 71,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.5,
        standardError68: 1.5,
        standardError95: 3,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 21,
      totalFuelSavingKgPreSignol: 82194.81,
      totalFuelSavingKgPostSignol: -24742.83,
      avgNetFuelSavingKgPreSignol: {
        value: 207,
        standardError68: 21,
        standardError95: 37,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.2,
        standardError68: 0.7,
        standardError95: 1.4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 387,
        standardError68: 84,
        standardError95: 105,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.4,
        standardError68: 1.5,
        standardError95: 3,
      },
      avgNetFuelSavingChangeKg: {
        value: 593,
        standardError68: 73,
        standardError95: 140,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.6,
        standardError68: 1.7,
        standardError95: 3.4,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      totalFuelSavingKgPreSignol: 153333.33,
      totalFuelSavingKgPostSignol: 37520.21,
      avgNetFuelSavingKgPreSignol: {
        value: 935,
        standardError68: 66,
        standardError95: 154,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 375,
        standardError68: 36,
        standardError95: 72,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.4,
        standardError68: 3.4,
        standardError95: 6.7,
      },
      avgNetFuelSavingChangeKg: {
        value: 560,
        standardError68: 41,
        standardError95: 81,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.6,
        standardError68: 3.9,
        standardError95: 7.6,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 10,
      totalFuelSavingKgPreSignol: 43.73133,
      totalFuelSavingKgPostSignol: -100.733574,
      avgNetFuelSavingKgPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 2,
        standardError68: 2,
        standardError95: 5,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingChangeKg: {
        value: 2,
        standardError68: 3,
        standardError95: 7,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
    },
  ],
  [moment.utc().subtract(3, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 23,
      totalFuelSavingKgPreSignol: 14664.382,
      totalFuelSavingKgPostSignol: 827.3356,
      avgNetFuelSavingKgPreSignol: {
        value: 299,
        standardError68: 28,
        standardError95: 62,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.3,
        standardError68: 0.8,
        standardError95: 1.6,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 22,
        standardError68: 2,
        standardError95: 9,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.02,
        standardError68: 0.57,
        standardError95: 1.12,
      },
      avgNetFuelSavingChangeKg: {
        value: 277,
        standardError68: 22,
        standardError95: 50,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.3,
        standardError68: 0.9,
        standardError95: 1.8,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 17,
      totalFuelSavingKgPreSignol: 82194.81,
      totalFuelSavingKgPostSignol: -82836.945,
      avgNetFuelSavingKgPreSignol: {
        value: 207,
        standardError68: 5,
        standardError95: 37,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.2,
        standardError68: 0.7,
        standardError95: 1.4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 1183,
        standardError68: 62,
        standardError95: 86,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 1.2,
        standardError68: 2.4,
        standardError95: 4.8,
      },
      avgNetFuelSavingChangeKg: {
        value: 1390,
        standardError68: 25,
        standardError95: 50,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 1.4,
        standardError68: 2.5,
        standardError95: 5,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      totalFuelSavingKgPreSignol: 153333.33,
      totalFuelSavingKgPostSignol: 58416.094,
      avgNetFuelSavingKgPreSignol: {
        value: 935,
        standardError68: 19,
        standardError95: 38,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 615,
        standardError68: 58,
        standardError95: 114,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.6,
        standardError68: 6,
        standardError95: 11.8,
      },
      avgNetFuelSavingChangeKg: {
        value: 320,
        standardError68: 61,
        standardError95: 121,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.3,
        standardError68: 6.6,
        standardError95: 12.9,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 37,
      totalFuelSavingKgPreSignol: 43.73133,
      totalFuelSavingKgPostSignol: -78508.02,
      avgNetFuelSavingKgPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 924,
        standardError68: 19,
        standardError95: 38,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: -0.9,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeKg: {
        value: 924,
        standardError68: 19,
        standardError95: 38,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
    },
  ],
  [moment.utc().subtract(4, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 10,
      totalFuelSavingKgPreSignol: 14664.382,
      totalFuelSavingKgPostSignol: -5394.0215,
      avgNetFuelSavingKgPreSignol: {
        value: 299,
        standardError68: 8,
        standardError95: 16,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.3,
        standardError68: 0.8,
        standardError95: 1.6,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 245,
        standardError68: 11,
        standardError95: 21,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.2,
        standardError68: 1.4,
        standardError95: 2.7,
      },
      avgNetFuelSavingChangeKg: {
        value: 544,
        standardError68: 13,
        standardError95: 27,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.5,
        standardError68: 1.5,
        standardError95: 3,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 21,
      totalFuelSavingKgPreSignol: 82194.81,
      totalFuelSavingKgPostSignol: -24742.83,
      avgNetFuelSavingKgPreSignol: {
        value: 207,
        standardError68: 7,
        standardError95: 13,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.2,
        standardError68: 0.7,
        standardError95: 1.4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 387,
        standardError68: 15,
        standardError95: 31,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.4,
        standardError68: 1.5,
        standardError95: 3,
      },
      avgNetFuelSavingChangeKg: {
        value: 593,
        standardError68: 17,
        standardError95: 34,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.6,
        standardError68: 1.7,
        standardError95: 3.4,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      totalFuelSavingKgPreSignol: 153333.33,
      totalFuelSavingKgPostSignol: 37520.21,
      avgNetFuelSavingKgPreSignol: {
        value: 935,
        standardError68: 19,
        standardError95: 38,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 375,
        standardError68: 36,
        standardError95: 72,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.4,
        standardError68: 3.4,
        standardError95: 6.7,
      },
      avgNetFuelSavingChangeKg: {
        value: 560,
        standardError68: 41,
        standardError95: 81,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.6,
        standardError68: 3.9,
        standardError95: 7.6,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 10,
      totalFuelSavingKgPreSignol: 43.73133,
      totalFuelSavingKgPostSignol: -100.733574,
      avgNetFuelSavingKgPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 2,
        standardError68: 2,
        standardError95: 5,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingChangeKg: {
        value: 2,
        standardError68: 3,
        standardError95: 7,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
    },
  ],
  [moment.utc().subtract(5, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_AUXILIARY_ENGINE_USE",
      behaviourName: "Efficient Auxiliary Engine Use",
      behaviourAcronym: "EAEU",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 22,
      countEventsPerformedPostSignol: 23,
      totalFuelSavingKgPreSignol: 14664.382,
      totalFuelSavingKgPostSignol: 827.3356,
      avgNetFuelSavingKgPreSignol: {
        value: 299,
        standardError68: 8,
        standardError95: 16,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.3,
        standardError68: 0.8,
        standardError95: 1.6,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 22,
        standardError68: 5,
        standardError95: 10,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.02,
        standardError68: 0.57,
        standardError95: 1.12,
      },
      avgNetFuelSavingChangeKg: {
        value: 277,
        standardError68: 9,
        standardError95: 19,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.3,
        standardError68: 0.9,
        standardError95: 1.8,
      },
    },
    {
      behaviourKey: "PROMPT_DEPARTURE",
      behaviourName: "Prompt Departure",
      behaviourAcronym: "PD",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 156,
      countEventsPerformedPostSignol: 17,
      totalFuelSavingKgPreSignol: 82194.81,
      totalFuelSavingKgPostSignol: -82836.945,
      avgNetFuelSavingKgPreSignol: {
        value: 207,
        standardError68: 7,
        standardError95: 13,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.2,
        standardError68: 0.7,
        standardError95: 1.4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 1183,
        standardError68: 24,
        standardError95: 48,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 1.2,
        standardError68: 2.4,
        standardError95: 4.8,
      },
      avgNetFuelSavingChangeKg: {
        value: 1390,
        standardError68: 25,
        standardError95: 50,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 1.4,
        standardError68: 2.5,
        standardError95: 5,
      },
    },
    {
      behaviourKey: "EFFICIENT_SFOC",
      behaviourName: "Efficient SFOC",
      behaviourAcronym: "ESFOC",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 46,
      countEventsPerformedPostSignol: 30,
      totalFuelSavingKgPreSignol: 153333.33,
      totalFuelSavingKgPostSignol: 58416.094,
      avgNetFuelSavingKgPreSignol: {
        value: 935,
        standardError68: 19,
        standardError95: 38,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 615,
        standardError68: 58,
        standardError95: 114,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.6,
        standardError68: 6,
        standardError95: 11.8,
      },
      avgNetFuelSavingChangeKg: {
        value: 320,
        standardError68: 61,
        standardError95: 121,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.3,
        standardError68: 6.6,
        standardError95: 12.9,
      },
    },
    {
      behaviourKey: "OPTIMAL_TRIM",
      behaviourName: "Optimal Trim",
      behaviourAcronym: "OT",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 38,
      countEventsPerformedPostSignol: 37,
      totalFuelSavingKgPreSignol: 43.73133,
      totalFuelSavingKgPostSignol: -78508.02,
      avgNetFuelSavingKgPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0,
        standardError68: 0,
        standardError95: 0,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 924,
        standardError68: 19,
        standardError95: 38,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeKg: {
        value: 924,
        standardError68: 19,
        standardError95: 38,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.9,
        standardError68: 2,
        standardError95: 4,
      },
    },
  ],
};

export const getBehaviourFuelSavingVsPreSignolRespMaritime = (
  teamId,
  startDate,
  endDate,
) => {
  let data = shippingAllTimeValues;
  if (startDate || endDate) {
    let monthsAgo =
      differenceInMonths(new Date(), new Date(endDate || startDate)) + 1;
    monthsAgo = monthsAgo > 5 ? 5 : monthsAgo; // just return the fifth month for any months further back in time
    data =
      shippingMonthyValues[
        moment.utc().subtract(monthsAgo, "months").format("YYYY/MM/DD")
      ];
  }
  return data;
};
